export default __webpack_public_path__ + "cab7893a6a5ea78a9c5949f45aff4ad2.svg";